import { compileCtpl } from "@client/lib/ctpl";
import * as React from "react";

export interface StyleProps {
  css?: string | null;
  ctpl?: string;
  data?: object;
  rootSelector?: string;
}

const Style = React.memo((props: StyleProps) => {
  const compiled = React.useMemo(() => {
    if (props.css) return;
    if (!props.ctpl || !props.data) return;

    return compileCtpl(props.ctpl, props.data);
  }, [props.ctpl, props.data]);

  if (props.css) {
    return <style type="text/css">{props.rootSelector ? `${props.rootSelector}{${props.css}}` : props.css}</style>;
  }

  if (compiled) {
    return <style type="text/css">{compiled}</style>;
  }

  return null;
});
export default Style;
